import { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { getCookie } from '@src/utils';
import { sendEventToWebView } from '@src/bridge/bridgeMessenger';
import { EWebViewEvents } from '@src/bridge';

interface IProps {
  seconds?: number;
}

const useRedirectTimer = ({ seconds = 30 }: IProps) => {
  const [timeLeft, setTimeLeft] = useState<number>(seconds);

  const navigate = useNavigate();

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (timeLeft > 0) {
      timer = setTimeout(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      localStorage.removeItem('hasJoined');
      const lastPath = getCookie('lastPath');
      if (lastPath) {
        navigate(lastPath);
      } else {
        navigate('/');
      }
      sendEventToWebView({ eventType: EWebViewEvents.CLOSE });
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [navigate, timeLeft]);

  return {
    timeLeft,
  };
};
export default useRedirectTimer;
